import { render, staticRenderFns } from "./HomeTopup.vue?vue&type=template&id=5ed4e85d"
import script from "./HomeTopup.vue?vue&type=script&lang=js"
export * from "./HomeTopup.vue?vue&type=script&lang=js"
import style0 from "./HomeTopup.vue?vue&type=style&index=0&id=5ed4e85d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports